module.exports = __webpack_public_path__ + "img/outline_bg_2023_01_19.1a99af78.png";